if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = this.form ? new FormData(this.form) : new FormData();
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      const extrasWidget = this.form
        ? Array.from(document.querySelectorAll('sofa-extras')).find((widget) => widget.dataset.productFormId === this.form.id)
        : null;
      const selectedExtras = extrasWidget ? extrasWidget.getSelectedItems() : [];
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (formData.has('selling_plan')) {
        formData.append('properties[_Anzahlung]', 'true');
      }

      if (selectedExtras.length) {
        const groupId = `sofa-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const properties = {};

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        });
        properties._sofa_extra_group = groupId;

        const mainItem = {
          id: Number(formData.get('id')),
          quantity,
          properties
        };
        if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));

        const items = [mainItem].concat(selectedExtras.map((extra) => ({
          id: extra.id,
          quantity,
          properties: {
            _sofa_extra_group: groupId,
            _sofa_extra_item: 'true',
            'Extra für': extrasWidget.dataset.productTitle
          }
        })));

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items,
          sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : undefined,
          sections_url: window.location.pathname
        });
      } else {
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if (extrasWidget) extrasWidget.showError(response.description || response.message || 'Die Extras konnten nicht hinzugefügt werden.');
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          if (extrasWidget) extrasWidget.reset();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
